import {
  emptyString,
  PAGINATION_INDEXING,
  LIST_PAGE_SIZE,
} from "../../../constants";

// Brand Groups screen constants (labels, default list query).
export const BRAND_GROUPS_DEFAULT_QUERY = {
  search: emptyString,
  from: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  take: LIST_PAGE_SIZE,
};

export const BRAND_GROUPS_LABELS = {
  GROUPS: "Groups",
  MANAGERS: "Managers",
  SEARCH_GROUPS: "Search groups",
  SEARCH_MANAGERS: "Search managers",
  GROUP_NAME: "GROUP NAME",
  NAME: "NAME",
  GROUP_NAME_COLUMN: "GROUP NAME",
  STORES: "STORES",
  STATUS: "STATUS",
  ACTIONS: "ACTIONS",
  CONFIRM: "Confirm",
  NO_GROUP_FOUND: "No Group Found",
  NO_MANAGER_FOUND: "No Manager Found",
  NO_LOCATIONS: "It has no locations",
  STATUS_TOOLTIP:
    "To activate a status, a Group Admin must be added through User Permissions.",
};
